import { ExpenseStatus } from 'domain/expenses/expenseStatus'
import { adminHttpClient } from '../commons/adminHttpClient'

export type DuplicateExpenseRequest = {
  expenseId?: string
  familyMemberId?: string
  requestedAmount: number
  purchasedDate: string
}

export type DuplicateExpense = {
  id: string
  requestedAmount: number
  createdAt: Date
  purchasedDate: Date
  status: ExpenseStatus
  lastReview: LastReview
}

type LastReview = {
  createdAt: Date
}

const getDuplicateExpense = (request: DuplicateExpenseRequest): Promise<DuplicateExpense | null> =>
  adminHttpClient.get('/Expenses/GetDuplicateExpense', request)

export default getDuplicateExpense
